<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc sub"><a href="#/front03">Introduction</a></p>
<p class="part"><a href="#/c001">The Long Decline</a></p>
<p class="toc"><a href="#/c01">Yankee Circus</a></p>
<p class="toc"><a href="#/c02">Adrift</a></p>
<p class="toc"><a href="#/c03">Buck Naked</a></p>
<p class="toc"><a href="#/c04">Stumped</a></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Dazed and Confused</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Banished</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">“Goodbye, George”</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">The Architect</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Prospecting</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Finding One Williams, Hiding the Other</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">Scouting and Hope</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">Yankee Clipper</span></p>
<p class="part"><span href="#/c002" title="Link target outside of Sample">Planting the Seeds</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Band of Brothers</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">The Yankee Way</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Culture Creators</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">An Ugly Duckling No More</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">Gamers</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">A Buzz</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">Lost Promise</span></p>
<p class="part"><span href="#/c003" title="Link target outside of Sample">Photos</span></p>
<p class="part"><span href="#/c004" title="Link target outside of Sample">Rebirth</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">A Spark</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">The Jewels</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">The Best Laid Plans Ruined</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">Like a Dagger</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">Really Bad Hangover</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">Limbo</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">Jedi Powers</span></p>
<p class="toc"><span href="#/c27" title="Link target outside of Sample">Yankee Flipper</span></p>
<p class="toc"><span href="#/c28" title="Link target outside of Sample">Last Stand</span></p>
<p class="toc"><span href="#/c29" title="Link target outside of Sample">“Did That Just Happen?”</span></p>
<p class="toc"><span href="#/c30" title="Link target outside of Sample">Purge</span></p>
<p class="toc"><span href="#/c31" title="Link target outside of Sample">The Living Room Summit</span></p>
<p class="toc"><span href="#/c32" title="Link target outside of Sample">The Pieces All Come Together</span></p>
<p class="toc"><span href="#/c33" title="Link target outside of Sample">To the Mountaintop</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Notes on Research and Sources</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc sub"><span href="#/back05" title="Link target outside of Sample">Index</span></p>
<p class="toc sub"><span href="#/back06" title="Link target outside of Sample">Sample Chapter from BILLY MARTIN</span></p>
<p class="toc sub"><span href="#/back07" title="Link target outside of Sample">Buy the Book</span></p>
<p class="toc sub"><span href="#/back08" title="Link target outside of Sample">About the Author</span></p>
<p class="toc sub"><span href="#/back09" title="Link target outside of Sample">Connect with HMH</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?3c68d180